import * as React from 'react';
import { shallow } from 'enzyme';
import { likeButtonDriverFactory } from './LikeButton.driver';
import { createRendererWithUniDriver } from '../../test/utils';
import { LikeButton } from '.';
import { LikeHeart } from '@wix/wix-ui-icons-common/on-stage';

describe('LikeButton', () => {
  const createDriver = createRendererWithUniDriver(likeButtonDriverFactory);
  const LABEL = 'Label';
  const ICON = <LikeHeart />;

  it('should render', async () => {
    const { driver } = createDriver(<LikeButton />);
    expect(await driver.exists()).toBe(true);
  });

  it('should call onChange', async () => {
    const onChangeSpy = jest.fn();
    const { driver } = createDriver(<LikeButton onChange={onChangeSpy} />);
    expect(onChangeSpy).not.toHaveBeenCalled();
    await driver.click();
    expect(onChangeSpy).toHaveBeenCalled();
  });

  it('should render label', async () => {
    const { driver } = createDriver(<LikeButton label={LABEL} />);
    expect(await driver.label.text()).toBe(LABEL);
  });

  it('should not render label when empty', async () => {
    const { driver } = createDriver(<LikeButton label="" />);
    expect(await driver.label.exists()).toBe(false);
  });

  it('should render Heart icon', async () => {
    const { driver } = createDriver(<LikeButton />);
    expect((await driver.icon.getNative()).innerHTML).toBe(
      shallow(ICON).html(),
    );
  });
});
